import React, { useEffect, useState } from "react";
import { Badge } from "reactstrap";

const FilterBubbles = ({ candidateReportFilter, clearSpecificFilter }) => {
  const [filterBubbleData, setFilterBubbleData] = useState([]);

  useEffect(() => {
    if (candidateReportFilter && candidateReportFilter.length > 0) {
      const filterBubbleDataMapped = candidateReportFilter?.map((item) => ({
        label: item.label,
        value: item.value ? item.value.split(",") : [],
        value2: item.value2 ? item.value2.split(",") : [],
      }));
      setFilterBubbleData(filterBubbleDataMapped);
    }
  }, [candidateReportFilter]);

  const generateFilterBubble = (item, index) => {
    if (item?.label === "Date Range") {
      return (
        (item?.value.length > 0 || item?.value2.length > 0) && (
          <Badge
            key={index}
            className="filter-bubble me-1 mb-1 d-inline-flex align-items-center"
            color="none"
          >
            <div className="d-flex flex-row align-items-center gap-1">
              <span className="fw-medium">{item.label}:</span>
              {/* // If value and value2 are not empty, display the date range */}
              {item?.value?.length > 0 && item?.value2.length > 0 && (
                <>
                  <span>{item.value[0]}</span>
                  <>
                    <span className="fw-medium">To</span>
                    <span>{item.value2[0]}</span>
                  </>
                </>
              )}
              {/* // If value is not empty but value2 is empty, display only the
              start date */}
              {item?.value?.length > 0 && item?.value2.length === 0 && (
                <>
                  <span>{item.value[0]}</span>
                  <span className="fw-medium">Till Today</span>
                </>
              )}
              {/* // If value2 is not empty but value is empty, display only the
                end date */}
              {item?.value?.length === 0 && item?.value2.length > 0 && (
                <>
                  <span className="fw-medium">Up Until</span>
                  <span>{item.value2[0]}</span>
                </>
              )}
              {(item.value.length > 1 || item.value2.length > 1) && (
                <div className="rounded-filter-length">
                  <span className="fw-medium">+{item.value.length}</span>
                </div>
              )}
              <span
                className="mdi mdi-close cursor-pointer"
                onClick={() => clearSpecificFilter(item.label)}
              ></span>
            </div>
          </Badge>
        )
      );
    } else {
      return (
        item.value.length !== 0 && (
          <Badge
            key={index}
            className="filter-bubble me-1 mb-1 d-inline-flex align-items-center"
            color="none"
          >
            <div className="d-flex flex-row align-items-center gap-1">
              <span className="fw-medium">{item.label}:</span>
              <span>{item.value[0]}</span>
              {item.value2.length !== 0 && (
                <>
                  <span className="fw-medium">to</span>
                  <span>{item.value2}</span>
                </>
              )}
              {item.value.length > 1 && (
                <div className="rounded-filter-length">
                  <span className="fw-medium">+{item.value.length}</span>
                </div>
              )}
              <span
                className="mdi mdi-close cursor-pointer"
                onClick={() => clearSpecificFilter(item.label)}
              ></span>
            </div>
          </Badge>
        )
      );
    }
  };

  return (
    <div>
      {filterBubbleData?.map((item, index) =>
        generateFilterBubble(item, index)
      )}
    </div>
  );
};

export default FilterBubbles;
